module.exports = __webpack_public_path__ + "img/weixin@3x.c7307dad.png";